import React from 'react';
import styled from 'styled-components';
import TimelineTimelineYearSingle from './TimelineTimelineYearsSingle';
import { P2 } from '../Typography';
import { COLOURS, DESKTOP_ELEMS } from './Timeline._constants';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const Container = styled.div `
  margin: 5px 0;
`;
const LinkDecade = styled(P2).attrs(() => ({
    tag: 'div',
})) `
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.trueBlack};
  font-weight: normal;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${COLOURS.RED_10};
  }

  &:before {
    color: ${COLOURS.RED_10};
    padding-right: 9px;
  }

  &.closed:before {
    content: '✚'; // 271a
    margin-right: 6px;
    padding: 0 6px 0 1.5px;
  }

  &.open:before {
    content: '−'; // 2212 or 268a
    font-weight: bold;
    display: inline-block;
    width: 2px;
    height: 18px;
    line-height: 13px;
    margin-left: -1px;
    margin-right: 9px;
    padding: 0 13px 10px 4px;
    background-color: ${COLOURS.RED_10};
    color: ${COLOURS.WHITE_10};
  }
`;
const LinksSingle = styled.div `
  margin: -1px 0 0 6px;
  padding-top: 5px;
  border-left: 2px solid ${COLOURS.RED_10};
  &.open {
    display: block;
    .highlight-year {
      span {
        color: ${({ theme }) => theme.primaryWhite};
      }
    }
  }
  &.closed {
    display: none;
  }
`;
const TimelineTimelineYearsDecade = ({ decade, years, setDecade, setLang, setId, handleClick, handleClickDecade } // setYear,
) => {
    // @todo  params & logic had already been set prior to using 's' for en/fr (refactor)
    // this is only to satisfy TS
    const isEn = setLang.indexOf('en') > -1;
    const suffix = isEn || true ? DESKTOP_ELEMS.DECADES.EN : '';
    const handleClickLocal = (evt, decadeYear) => {
        evt.preventDefault();
        evt.stopPropagation();
        handleClickDecade(decadeYear);
    };
    // fix for IE 11
    const handleDecadeClickEffect = (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
    };
    return (React.createElement(Container, null,
        React.createElement(OnClickFocusWrapper, null,
            React.createElement(LinkDecade, { asWhite: false, field: { value: decade + suffix }, className: decade === setDecade ? 'open' : 'closed', onClick: (evt) => handleClickLocal(evt, decade), "aria-expanded": decade === setDecade, role: "button", tabIndex: "0" })),
        React.createElement(LinksSingle, { className: decade === setDecade ? 'open' : 'closed', onClick: handleDecadeClickEffect }, years &&
            years.length > 0 &&
            years.map((item) => {
                return (React.createElement(TimelineTimelineYearSingle, { handleClick: handleClick, key: `s${item.id}`, year: item.year, id: item.id, isMobile: false, tabIndex: decade === setDecade ? 0 : -1, ariaExpanded: item.id === setId }));
            }))));
};
export default TimelineTimelineYearsDecade;
//  @see setHighlightClassMod
//  className={(item.year === setYear && item.id === setId) ? MOBILE_ELEMS.HIGHLIGHT.replace('.', '') : ''}
